/*
 * @Author: 丨小小风离丨
 * @Date: 2024-03-04 08:46:45
 * @LastEditTime: 2024-10-17 16:55:23
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\enrollPlan\list\planList.tsx
 * @Description: 
 */
import CountdownTimer from "@/components/countdownTimer";
import StatusTips from "@/components/statusTips";
import { LgButton, LgSealMark } from "lancoo-web-ui";
import { useDispatch, useSelector } from "react-redux";
import { selectUserId, selectUserInfo, setIsPopoverVisible } from "../../../store/reducers/userInfo";
import { getSealMarkInfo, nameTips } from "../common/publicFunc";
import './planList.scss';
import { useRef } from "react";
import { selectSchoolLevel } from "../../../store/reducers/schoolInfo";
import { enrollInfo } from "@/page/constants";

export default function PlanList(props: any) {
    const {
        list = [],
        optionFun
    } = props;

    const dispatch = useDispatch();

    const userId = useSelector(selectUserId);
    const { userType } = useSelector(selectUserInfo);
    const schoolLevel = useSelector(selectSchoolLevel); // 获取学校类型

    return (
        <div className="plan_detail_header">
            {list?.length > 0 && list?.map(ele => {
                // 在线报名能点击进行查看
                const canClick = ele?.enableApply == 1 && ele?.applyStatus !== 1
                return <div
                    key={ele.planId}
                    className="con_list_wrapper"
                    onClick={(e) => {
                        optionFun.checkPlan(ele)
                    }}
                >
                    <div className="con_list">
                        <div className="list">
                            <div
                                className="coverimg"
                                style={{
                                    backgroundImage: `url(${ele?.coverImg?.[0]?.preUrl || ''})`,
                                    cursor: 'pointer'
                                }}
                            >
                            </div>
                            <div className="moremsg">
                                <div className="title">
                                    {ele?.planName || ''}
                                    <StatusTips
                                        style={{ color: nameTips(ele || 0).color }}
                                        text={nameTips(ele || 0).text}
                                    />
                                </div>
                                <div style={{ marginBottom: 5 }}>
                                    招生年份:
                                    <span className="content">
                                        {/* 2023-2024学年 */}
                                        {ele?.planYear}
                                    </span>
                                    {schoolLevel === 2 && <>
                                        招生年级:
                                        <span className="content">
                                            {ele?.planGradeName || "新年级"}
                                        </span>
                                    </>}
                                    {schoolLevel === 2 && <>
                                        学费金额:
                                        <span className="content">
                                            {ele?.paymentAmount || '--'}元
                                        </span>
                                    </>}
                                    招生人数:
                                    <span className="content">
                                        {ele?.planNum || '--'}
                                    </span>
                                    {schoolLevel !== 2 && <>
                                        是否允许在线报名:
                                        <span className="content">
                                            {ele?.applyStatus == 1 ? '否' : '是'}
                                        </span>
                                    </>}
                                </div>
                                <div style={{ marginBottom: 5 }}>
                                    {schoolLevel === 2 && <>
                                        是否允许在线报名:
                                        <span className="content">
                                            {ele?.applyStatus == 1 ? '否' : '是'}
                                        </span>
                                    </>}
                                    咨询老师:
                                    <span className="content">
                                        {ele?.consultant.split("-")[1] || "--"}
                                    </span>
                                    咨询电话:
                                    <span className="content">
                                        {ele?.contact || "--"}
                                    </span>
                                </div>
                                <div>
                                    招生时间:
                                    <span className="content">
                                        {ele?.planStartTime + '~' + ele?.planEndTime}
                                    </span>
                                    {
                                        enrollInfo[ele?.enrollBatchType]?
                                        <>
                                        招生类型:
                                        <span className="content">
                                            {enrollInfo[ele?.enrollBatchType]}
                                        </span>
                                        </>:
                                        ""
                                    }
                                    
                                </div>
                            </div>
                        </div>

                        <div className="btn">
                            {ele?.enableApply === 3
                                &&
                                <img src={require(`../images/${getSealMarkInfo(ele).imgSrc}`)} width={99} height={75} alt="" />
                                // <LgSealMark
                                //     status={
                                //         getSealMarkInfo(ele).status
                                //     }
                                //     style={{ width: 98, opacity: 0.5 }}
                                // >
                                //     {getSealMarkInfo(ele).text}
                                // </LgSealMark>
                            }

                            <div style={{
                                margin: "0 34px",
                                width: '1px',
                                height: '94px',
                                // backgroundImage: "linear-gradient(to right, white, white 50%, #e5e5e5 50%, #e5e5e5)",
                                background: "linear-gradient(to bottom, white 0%, #e5e5e5 50%, white 100%)",
                            }}></div>
                            <div style={{ display: 'flex', flexFlow: 'column' }}>
                                {/* <LgButton
                                    onClick={() => optionFun.checkPlan(ele)}
                                    backgroundType='opacification'
                                    type='info'
                                    style={{ marginBottom: 8 }}
                                >
                                    查看计划
                                </LgButton> */}
                                <span
                                    onClick={(e) => {
                                        e.stopPropagation()

                                        if (canClick) {
                                            return
                                        }
                                        dispatch(setIsPopoverVisible(false));
                                        optionFun.enroll(ele, 'priview');
                                    }}
                                >
                                    <LgButton
                                        backgroundType={ele?.enableApply === 3 ? 'translucent' : 'opacification'}
                                        border={ele?.enableApply === 3}
                                        type='info'
                                        style={{ justifyContent: 'center', width: 118 }}
                                        // 在线报名能点击进行查看
                                        disable={ele?.applyStatus === 1 ? false : ele?.enableApply == 1}
                                    >
                                        {
                                            ele?.enableApply === 3 ? `查看${ele?.planStatus === 2 ? '审核' : ele?.planStatus === 3 ? ele?.admissionInfo ? '录取' : '审核' : '报名'}信息` :
                                                ele?.applyStatus == 1 ? '查看' : (userType === 20 && userId) ? "代报名" : '去报名'
                                        }
                                    </LgButton>
                                </span>
                                {(() => {
                                    
                                    let enrollFlag = ele?.planStatus === 1 && ele?.enableApply !== 3 && ele?.applyStatus !== 1

                                    return <div style={{ marginTop: 8, textAlign: 'center', color: '#ff7113', fontSize: 12 }}>
                                        <CountdownTimer endDate={enrollFlag ? ele?.applyEndTime : ele?.planEndTime} />
                                        {enrollFlag ? '报名':'计划'}结束
                                    </div>
                                })()}
                            </div>
                        </div>
                    </div>
                    <div style={{ width: '100%', height: 1, backgroundColor: '#000000', opacity: 0.12 }}></div>
                </div>
            })}
        </div>
    );
};
